/* basic. production runtime adapter */
/* Decorative controls share the same vector drawing as the header icons. */
const basicIconPaths = {
  '▶': 'M8 5.5 18 12 8 18.5Z',
  '→': 'M4 12h16m-6-6 6 6-6 6',
  '←': 'M20 12H4m6-6-6 6 6 6',
  '↑': 'M12 20V4m-6 6 6-6 6 6',
  '↓': 'M12 4v16m-6-6 6 6 6-6',
  '↗': 'M5 19 19 5M6 5h13v13',
  '↘': 'M5 5 19 19M6 19h13V6',
  'chevron': 'm6 9 6 6 6-6',
  'close': 'm5 5 14 14M19 5 5 19'
};
function basicControlIcon(kind) {
  return `<svg class="basic-ui-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="${basicIconPaths[kind]}"/></svg>`;
}
function refineControlIcons(root = document) {
  root.querySelectorAll('span[aria-hidden="true"]').forEach(span => {
    const kind = span.textContent.trim();
    if (!Object.hasOwn(basicIconPaths, kind)) return;
    span.innerHTML = basicControlIcon(kind);
    span.dataset.uiIconReady = '';
  });
  root.querySelectorAll('.mobile-nav-group > summary').forEach(summary => {
    if (summary.querySelector('.mobile-nav-chevron')) return;
    const chevron = document.createElement('span');
    chevron.className = 'mobile-nav-chevron';
    chevron.setAttribute('aria-hidden', 'true');
    chevron.innerHTML = basicControlIcon('chevron');
    summary.append(chevron);
    summary.dataset.uiIconReady = '';
  });
  root.querySelectorAll('button[aria-label]').forEach(button => {
    const kind = button.textContent.trim();
    if (!Object.hasOwn(basicIconPaths, kind)) return;
    button.innerHTML = basicControlIcon(kind);
  });
  root.querySelectorAll('.kit-ugc-close').forEach(button => {
    if (button.querySelector('svg')) return;
    button.innerHTML = basicControlIcon('close');
  });
}
refineControlIcons();
// Account controls are inserted by a later deferred script.
if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', () => refineControlIcons(), {once:true});

/* A compact mobile footer, with the full directory retained on desktop. */
function initFooterNavigation() {
  document.querySelectorAll('.site-wide-footer').forEach(footer => {
    if (footer.dataset.footerReady) return;
    const directory = footer.querySelector('.site-footer-directory');
    if (!directory) return;
    const language = document.documentElement.lang.slice(0, 2);
    const copy = ({
      fr: {shortcuts:'Aide et points de vente'},
      de: {shortcuts:'Hilfe und Verkaufsstellen'},
      en: {shortcuts:'Help and stockists'}
    })[language] || {shortcuts:'Aide et points de vente'};
    const footerLinks = [...footer.querySelectorAll('.site-footer-group nav a')];
    const findLink = endings => footerLinks.find(link => endings.includes(new URL(link.href, location.href).pathname.split('/').pop()));
    const shortcutLinks = [
      {link:findLink(['contact.html','contact']), path:'M4 5h16v11H9l-5 4V5Z M8 9h8M8 12h5'},
      {link:findLink(['faq.html','faq']), path:'M9.5 9a2.5 2.5 0 1 1 4.3 1.7c-1.3.7-1.8 1.3-1.8 2.8M12 17h.01', circle:true},
      {link:findLink(['points-de-vente.html','points-de-vente']), path:'M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z', pin:true}
    ];
    const oldCallout = footer.querySelector('.site-footer-diagnostic');
    if (oldCallout && shortcutLinks.every(item => item.link)) {
      const shortcuts = document.createElement('nav');
      shortcuts.className = 'site-footer-shortcuts';
      shortcuts.setAttribute('aria-label', copy.shortcuts);
      shortcutLinks.forEach(item => {
        const link = item.link.cloneNode(true);
        link.className = 'site-footer-shortcut';
        const label = document.createElement('span');
        label.textContent = link.textContent;
        link.replaceChildren(label);
        link.insertAdjacentHTML('afterbegin', `<svg class="basic-ui-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${item.circle ? '<circle cx="12" cy="12" r="9"/>' : ''}<path d="${item.path}"/>${item.pin ? '<circle cx="12" cy="10" r="2.5"/>' : ''}</svg>`);
        shortcuts.append(link);
      });
      oldCallout.replaceWith(shortcuts);
    }
    const disclosures = [...directory.querySelectorAll('.site-footer-group')].map(group => {
      const heading = group.querySelector('h2');
      const nav = group.querySelector('nav');
      if (!heading || !nav) return null;
      const details = document.createElement('details');
      details.className = 'site-footer-group site-footer-disclosure';
      const summary = document.createElement('summary');
      const label = document.createElement('span');
      label.textContent = heading.textContent;
      summary.append(label);
      summary.insertAdjacentHTML('beforeend', basicControlIcon('chevron'));
      details.append(summary, heading, nav);
      group.replaceWith(details);
      return details;
    }).filter(Boolean);
    const topLink = footer.querySelector('.site-footer-top');
    if (topLink) {
      // A sticky header is already visible, so its fragment does not scroll up.
      topLink.setAttribute('href', '#');
      topLink.addEventListener('click', event => {
        event.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
        document.querySelector('#site-header a')?.focus({preventScroll: true});
      });
      const label = document.createElement('span');
      label.className = 'site-footer-top-label';
      const text = [...topLink.childNodes].filter(node => node.nodeType === Node.TEXT_NODE);
      label.textContent = text.map(node => node.textContent).join('').trim();
      text.forEach(node => node.remove());
      topLink.prepend(label);
    }
    footer.id ||= 'site-footer';
    footer.dataset.footerReady = 'true';
    const mobile = window.matchMedia('(max-width: 900px)');
    let mobileMode = null;
    function syncFooterMode() {
      if (mobileMode === mobile.matches) return;
      mobileMode = mobile.matches;
      disclosures.forEach(details => {
        // Keep focus on a visible control if the viewport switches modes.
        const summaryHadFocus = document.activeElement === details.querySelector('summary');
        if (mobileMode && details.querySelector('nav').contains(document.activeElement)) {
          details.querySelector('summary').focus();
        }
        details.open = !mobileMode;
        if (!mobileMode && summaryHadFocus) details.querySelector('nav a')?.focus();
      });
    }
    disclosures.forEach(details => details.addEventListener('toggle', () => {
      if (mobile.matches && details.open) {
        disclosures.forEach(other => { if (other !== details) other.open = false; });
      }
    }));
    syncFooterMode();
    mobile.addEventListener('change', syncFooterMode);
  });
}
initFooterNavigation();

const kitUrl = 'kit-deodorant.html';
const menuProductPreviews = {
  'kit-deodorant.html': window.BasicShopifyConfig.assets["assets/kit-application-coton-03.jpg"],
  'le-classik.html': window.BasicShopifyConfig.assets["assets/pdp-classik-application.jpg"],
  'produit-applicateur-de-deodorant-rechargeable-kiima.html': window.BasicShopifyConfig.assets["assets/kit-refill-coton-13.jpg"],
  'produit-recharge-deodorant-naturel-le-classik.html': "https://cdn.shopify.com/s/files/1/0741/5188/7112/files/basic-deodorant-classik-recharge-20261102.jpg?v=1793608932",
  'produit-recharge-deodorant-solide-naturel-floral.html': "https://cdn.shopify.com/s/files/1/0741/5188/7112/files/basic-deodorant-floral-recharge-20261102.jpg?v=1793608942",
  'le-boise.html': "https://cdn.shopify.com/s/files/1/0741/5188/7112/files/basic-deodorant-boise-recharge-20261102.jpg?v=1793608921",
  'produit-recharge-deodorant-solide-naturel-peaux-sensibles.html': "https://cdn.shopify.com/s/files/1/0741/5188/7112/files/basic-deodorant-sensible-recharge-20261102.jpg?v=1793608951",
  'produit-serum-nude.html': window.BasicShopifyConfig.assets["assets-nude/serum-usage.jpg"],
  'produit-serum-calm.html': window.BasicShopifyConfig.assets["assets/best-calm.jpg"],
  'serum-sage.html': window.BasicShopifyConfig.assets["assets-families/sage-serum-sage-4.jpg"],
  'produit-huile-demaquillante.html': window.BasicShopifyConfig.assets["assets/sage-oil-use.jpg"],
  'produit-brume-visage.html': window.BasicShopifyConfig.assets["assets-nude/brume-usage.jpg"],
  'produit-creme-visage-peau-mixte-grasse.html': window.BasicShopifyConfig.assets["assets-audited/creme-visage-application.jpg"],
  'kit-baume-levres.html': window.BasicShopifyConfig.assets["assets-palette/mon-baume-a-levres-rechargeable-kit-de-depart.webp"],
  'produit-le-pure-baume-a-levres-rechargeable.html': "https://cdn.shopify.com/s/files/1/0741/5188/7112/files/basic-baume-nude-recharge-20261102.jpg?v=1793608901",
  'produit-cure-baume-a-levres-rechargeable.html': "https://cdn.shopify.com/s/files/1/0741/5188/7112/files/basic-baume-cure-recharge-20261102.jpg?v=1793608891",
  'produit-glow-baume-a-levres-rosea.html': "https://cdn.shopify.com/s/files/1/0741/5188/7112/files/basic-baume-rosea-recharge-20261102.jpg?v=1793608912",
  'produit-glow-baume-a-levres-brunea.html': "https://cdn.shopify.com/s/files/1/0741/5188/7112/files/basic-baume-brunea-recharge-20261102.jpg?v=1793608881",
  'produit-applicateur-baume-a-levres-rechargeable-kiima.html': window.BasicShopifyConfig.assets["assets/menu-lip-use.jpg"],
  'produit-huile-sublime.html': window.BasicShopifyConfig.assets["assets-palette/huile-sublime.webp"],
  'produit-baume-mains-reparateur.html': window.BasicShopifyConfig.assets["assets-palette/baume-mains-reparateur.webp"],
  'produit-gel-aloe-vera-bio-le-soin-naturel-ultime-pour-votre-peau.html': window.BasicShopifyConfig.assets["assets/best-aloe-routine.jpg"],
  'produit-savon-bio-huile-laurier-100g.html': window.BasicShopifyConfig.assets["assets-palette/savon-bio-huile-laurier-100g.webp"],
  'produit-shampoing-solide-naturel-tous-types-cheveux.html': window.BasicShopifyConfig.assets["assets-palette/secondary-shampoing-nude-detail.webp"],
  'produit-shampoing-solide-naturel-cheveux-secs.html': window.BasicShopifyConfig.assets["assets-palette/secondary-shampoing-cure-detail.webp"],
  'produit-shampoing-solide-naturel-cheveux-gras.html': window.BasicShopifyConfig.assets["assets-palette/secondary-shampoing-pure-detail.webp"],
  'produit-huile-ricin-bio-pousse-cheveux-cils-ongles.html': window.BasicShopifyConfig.assets["assets-palette/huile-ricin-bio-pousse-cheveux-cils-ongles.webp"],
  'produit-huile-de-jojoba-biologique-pressee-a-froid-50ml.html': window.BasicShopifyConfig.assets["assets-audited/huile-jojoba-studio.jpg"],
  'produit-huile-damande-douce-biologique-pressee-a-froid-50ml.html': window.BasicShopifyConfig.assets["assets-palette/secondary-huile-amande-studio.webp"],
  'produit-huile-dargan-biologique-pressee-a-froid-50ml.html': window.BasicShopifyConfig.assets["assets-palette/secondary-huile-argan-studio.webp"],
  'produit-huile-macadamia-bio-nourrissante-reparatrice.html': window.BasicShopifyConfig.assets["assets-palette/huile-macadamia-bio-nourrissante-reparatrice.webp"],
  'produit-huile-avocat-bio-reparatrice-peau-seche.html': window.BasicShopifyConfig.assets["assets-palette/huile-avocat-bio-reparatrice-peau-seche.webp"],
  'produit-huile-noisette-bio-purifiante-peau-acneique.html': window.BasicShopifyConfig.assets["assets-palette/huile-noisette-bio-purifiante-peau-acneique.webp"],
  'produit-huile-abricot-bio-eclat-peau-terne.html': window.BasicShopifyConfig.assets["assets-palette/huile-abricot-bio-eclat-peau-terne.webp"],
  'produit-huile-sesame-bio-detox-assouplissante.html': window.BasicShopifyConfig.assets["assets-palette/huile-sesame-bio-detox-assouplissante.webp"]
};
const menuSerumGuidance = {
  'produit-serum-nude.html': { fr: 'Peaux normales à mixtes', de: 'Normale Haut bis Mischhaut', en: 'Normal to combination skin' },
  'produit-serum-calm.html': { fr: 'Peaux sensibles ou réactives', de: 'Empfindliche oder reaktive Haut', en: 'Sensitive or reactive skin' },
  'serum-sage.html': { fr: 'Peaux matures', de: 'Reife Haut', en: 'Mature skin' }
};
function menuSerumHint(page) {
  const guidance = menuSerumGuidance[page];
  if (!guidance) return '';
  const language = document.documentElement.lang.slice(0, 2).toLowerCase();
  return guidance[language] || guidance.fr;
}
function initMobileSerumGuidance() {
  document.querySelectorAll('.mobile-menu .mobile-links a[href]').forEach(link => {
    const page = Object.keys(menuSerumGuidance).find(page => {
      const pathname = new URL(link.href, document.baseURI).pathname;
      const target = window.basicLocale?.url(page) || window.BasicShopifyConfig?.routes?.local?.[page] || page;
      return pathname.endsWith(`/${page}`) || new URL(target, document.baseURI).pathname === pathname;
    });
    if (!page || link.querySelector('.menu-product-hint')) return;
    const name = document.createElement('span');
    name.className = 'menu-product-name';
    name.append(...link.childNodes);
    const hint = document.createElement('small');
    hint.className = 'menu-product-hint';
    hint.textContent = menuSerumHint(page);
    link.replaceChildren(name, hint);
    link.classList.add('menu-product-choice');
  });
}
initMobileSerumGuidance();

const productLink = (title, url, preview, caption) => {
  preview = menuProductPreviews[url] || preview;
  const hint = menuSerumHint(url);
  const label = hint ? `<span class="menu-product-copy"><span class="menu-product-name">${title}</span><small class="menu-product-hint">${hint}</small></span>` : title;
  return `<a class="mega-link${hint ? ' menu-product-choice' : ''}" href="${url}"${/^https?:\/\//.test(url) ? ' target="_blank" rel="noopener noreferrer"' : ''}${preview ? ` data-preview="${preview}" data-preview-caption="${caption || title}"` : ''}>${label}<span aria-hidden="true">→</span></a>`;
};
const family = (name, verb) => window.BasicShopifyConfig.transformHTML(`<a class="mega-family" href="${name}.html"><i style="--swatch:var(--${name})" aria-hidden="true"></i><strong>${name}</strong>${verb ? ` ${verb}` : ''}</a>`);
const feature = (url, image, eyebrow, title, kind = '') => `<a class="mega-feature${kind ? ` mega-feature--${kind}` : ''}" href="${url}" data-default-href="${url}"${/^https?:\/\//.test(url) ? ' target="_blank" rel="noopener noreferrer"' : ''}><img class="mega-feature-image" src="${image}" data-default-src="${image}" alt="" loading="lazy" /><span class="mega-feature-caption"><small>${eyebrow}</small><strong class="mega-feature-title" data-default-title="${title}">${title}</strong></span></a>`;

const menus = {
  deodorants: {
    width: 1010, height: 410,
    html: window.BasicShopifyConfig.transformHTML(`<div class="mega-layout wide"><div><span class="mega-eyebrow">Pour commencer</span>${productLink('Le kit déodorant rechargeable',kitUrl)}${productLink('Le Classik · crème 50 ou 100 g','le-classik.html','assets/best-classik.jpg','Le Classik')}${productLink('L’applicateur rechargeable','produit-applicateur-de-deodorant-rechargeable-kiima.html')}</div><div><span class="mega-eyebrow">Les recharges</span>${productLink('Le Classik','produit-recharge-deodorant-naturel-le-classik.html')}${productLink('Le Floral','produit-recharge-deodorant-solide-naturel-floral.html')}${productLink('Le Boisé','le-boise.html','assets-nude/refill-boise.jpg','Le Boisé')}${productLink('Le Sensible','produit-recharge-deodorant-solide-naturel-peaux-sensibles.html')}<a class="mega-small-link" href="catalogue.html?categorie=deodorants">Tous les déodorants <span aria-hidden="true">→</span></a></div>${feature('produit-recharge-deodorant-naturel-le-classik.html','https://cdn.shopify.com/s/files/1/0741/5188/7112/files/basic-deodorant-classik-recharge-20261102.jpg?v=1793608932','Les recharges','Le Classik','deodorants')}</div>`)
  },
  visage: {
    width: 990, height: 404,
    html: window.BasicShopifyConfig.transformHTML(`<div class="mega-layout mega-layout--three"><div><span class="mega-eyebrow">Les sérums</span>${productLink('Sérum Nude','produit-serum-nude.html','https://cdn.shopify.com/s/files/1/0741/5188/7112/files/serum_nude5.jpg?v=1778179073')}${productLink('Sérum Calm','produit-serum-calm.html','https://cdn.shopify.com/s/files/1/0741/5188/7112/files/serum_calm5.jpg?v=1778180943')}${productLink('Sérum Sage','serum-sage.html','assets-families/sage-serum-sage-4.jpg')}<a class="mega-small-link" href="catalogue.html?categorie=visage&amp;q=kit">Tous les kits visage <span aria-hidden="true">→</span></a></div><div><span class="mega-eyebrow">Les gestes essentiels</span>${productLink('Huile démaquillante','produit-huile-demaquillante.html','assets/sage-oil-use.jpg')}${productLink('Brume visage','produit-brume-visage.html','https://cdn.shopify.com/s/files/1/0741/5188/7112/files/brume_5_png.jpg?v=1778166486')}${productLink('Crème visage','produit-creme-visage-peau-mixte-grasse.html','assets-audited/creme-visage-application.jpg')}<a class="mega-small-link" href="rituel-visage.html">Le rituel visage <span aria-hidden="true">→</span></a><a class="mega-small-link" href="catalogue.html?categorie=visage">Tous les soins visage <span aria-hidden="true">→</span></a><a class="mega-small-link" href="diagnostic.html">Diagnostic peau <span aria-hidden="true">→</span></a></div>${feature('rituel-visage.html','assets-nude/brume-usage.jpg','À ta façon','Le rituel visage','visage')}</div>`)
  },
  levres: {
    width: 760, height: 390,
    html: window.BasicShopifyConfig.transformHTML(`<div class="mega-layout medium"><div><span class="mega-eyebrow">Le baume rechargeable</span>${productLink('Kit baume à lèvres','kit-baume-levres.html')}${productLink('Baume Nude','produit-le-pure-baume-a-levres-rechargeable.html')}${productLink('Baume Cure','produit-cure-baume-a-levres-rechargeable.html')}${productLink('Baume Roséa','produit-glow-baume-a-levres-rosea.html')}${productLink('Baume Brunea','produit-glow-baume-a-levres-brunea.html')}${productLink('Applicateur seul','produit-applicateur-baume-a-levres-rechargeable-kiima.html')}<a class="mega-small-link" href="catalogue.html?categorie=levres">Tous les baumes <span aria-hidden="true">→</span></a></div>${feature('produit-le-pure-baume-a-levres-rechargeable.html','https://cdn.shopify.com/s/files/1/0741/5188/7112/files/basic-baume-nude-recharge-20261102.jpg?v=1793608901','Le geste rechargeable','Baume Nude','levres')}</div>`)
  },
  corps: {
    width: 720, height: 354,
    html: window.BasicShopifyConfig.transformHTML(`<div class="mega-layout medium"><div><span class="mega-eyebrow">Les soins corps</span>${productLink('Huile Sublime','produit-huile-sublime.html')}${productLink('Baume mains réparateur','produit-baume-mains-reparateur.html')}${productLink('Gel d’aloe vera','produit-gel-aloe-vera-bio-le-soin-naturel-ultime-pour-votre-peau.html')}${productLink('Savon de laurier','produit-savon-bio-huile-laurier-100g.html')}<a class="mega-small-link" href="catalogue.html?categorie=corps">Tous les soins corps <span aria-hidden="true">→</span></a></div>${feature('catalogue.html?categorie=corps','assets/menu-body-use.jpg','Pour le corps','Un moment à soi.','corps')}</div>`)
  },
  cheveux: {
    width: 720, height: 354,
    html: window.BasicShopifyConfig.transformHTML(`<div class="mega-layout medium"><div><span class="mega-eyebrow">Les soins cheveux</span>${productLink('Shampoing · tous types','produit-shampoing-solide-naturel-tous-types-cheveux.html')}${productLink('Shampoing · cheveux secs','produit-shampoing-solide-naturel-cheveux-secs.html')}${productLink('Shampoing · cheveux gras','produit-shampoing-solide-naturel-cheveux-gras.html')}${productLink('Huile de ricin','produit-huile-ricin-bio-pousse-cheveux-cils-ongles.html')}<a class="mega-small-link" href="catalogue.html?categorie=cheveux">Tous les soins cheveux <span aria-hidden="true">→</span></a></div>${feature('catalogue.html?categorie=cheveux','assets/menu-hair-use.jpg','Pour les cheveux','Le soin dans la routine.','cheveux')}</div>`)
  },
  huiles: {
    width: 1010, height: 404,
    html: window.BasicShopifyConfig.transformHTML(`<div class="mega-layout mega-layout--three"><div><span class="mega-eyebrow">Les huiles végétales</span>${productLink('Jojoba','produit-huile-de-jojoba-biologique-pressee-a-froid-50ml.html')}${productLink('Amande douce','produit-huile-damande-douce-biologique-pressee-a-froid-50ml.html')}${productLink('Argan','produit-huile-dargan-biologique-pressee-a-froid-50ml.html')}${productLink('Macadamia','produit-huile-macadamia-bio-nourrissante-reparatrice.html')}${productLink('Avocat','produit-huile-avocat-bio-reparatrice-peau-seche.html')}</div><div><span class="mega-eyebrow">À explorer</span>${productLink('Noisette','produit-huile-noisette-bio-purifiante-peau-acneique.html')}${productLink('Noyau d’abricot','produit-huile-abricot-bio-eclat-peau-terne.html')}${productLink('Ricin','produit-huile-ricin-bio-pousse-cheveux-cils-ongles.html')}${productLink('Sésame','produit-huile-sesame-bio-detox-assouplissante.html')}${productLink('Huile Sublime','produit-huile-sublime.html')}<a class="mega-small-link" href="catalogue.html?categorie=huiles">Toutes les huiles <span aria-hidden="true">→</span></a></div>${feature('produit-huile-sublime.html','assets-palette/huile-sublime.webp','Les huiles végétales','Huile Sublime','huiles')}</div>`)
  },
  basic: {
    width: 1010, height: 405,
    html: `<div class="mega-layout mega-layout--three"><div><span class="mega-eyebrow">Les sept familles</span><div class="mega-families">${family('aqua','hydrater')}${family('cure','nourrir')}${family('calm','apaiser')}${family('nude','équilibrer')}${family('sage','raffermir')}${family('pure','purifier')}${family('glow','illuminer')}</div></div><div><span class="mega-eyebrow">À découvrir</span>${productLink('Les best-sellers','bestsellers.html')}${productLink('Kits & routines','packs.html')}${productLink('Idées cadeaux','coffrets-cadeaux.html')}${productLink('Le club','le-club.html')}${productLink('Notre histoire','a-propos.html')}${productLink('Notre engagement','notre-engagement.html')}${productLink('Le journal','blog.html')}${productLink('Événements','evenements.html')}</div><div><span class="mega-eyebrow">À tes côtés</span>${productLink('Tous les produits','catalogue.html')}${productLink('Diagnostic peau','diagnostic.html')}${productLink('Aide & FAQ','faq.html')}${productLink('Livraison & retours','livraison-retours.html')}${productLink('Points de vente','points-de-vente.html')}${productLink('Contact','contact.html')}${productLink('Professionnelles','professionnelles.html')}</div></div>`
  }
};

const header = document.querySelector('#site-header');
const menuPanel = document.querySelector('#mega-panel');
const menuInner = document.querySelector('#mega-inner');
const triggers = [...document.querySelectorAll('.nav-trigger')];
let activeMenu = null;
let closeTimer = null;
let renderTimer = null;
let menuSequence = 0;
const menuPreviewImages = new Map();
const menuPreviewStates = new WeakMap();

function loadMenuPreview(src) {
  if (!menuPreviewImages.has(src)) {
    const image = new Image();
    image.src = src;
    menuPreviewImages.set(src, image.decode().then(() => true).catch(() => {
      menuPreviewImages.delete(src);
      return false;
    }));
  }
  return menuPreviewImages.get(src);
}

function preloadMenuPreviews() {
  menuInner.querySelectorAll('[data-preview]').forEach(item => loadMenuPreview(item.dataset.preview));
}

async function updateProductPreview(item) {
  const card = menuPanel.querySelector('.mega-feature');
  const image = card?.querySelector('.mega-feature-image');
  const title = card?.querySelector('.mega-feature-title');
  if (!image || !title) return;
  const src = item.dataset.preview || image.dataset.defaultSrc;
  const state = menuPreviewStates.get(card) || { src: null, item: null, sequence: 0 };
  if (state.src === src && state.item === item) return;
  state.src = src;
  state.item = item;
  const sequence = ++state.sequence;
  const menu = activeMenu;
  menuPreviewStates.set(card, state);
  if (!await loadMenuPreview(src)) {
    if (sequence === state.sequence) state.src = null;
    return;
  }
  if (sequence !== state.sequence || activeMenu !== menu || !card.isConnected) return;

  card.querySelector('.mega-feature-transition')?.remove();
  if (image.getAttribute('src') !== src) {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const previous = image.cloneNode(false);
      previous.className = 'mega-feature-transition';
      previous.style.objectPosition = getComputedStyle(image).objectPosition;
      previous.setAttribute('aria-hidden', 'true');
      previous.loading = 'eager';
      card.append(previous);
      previous.getBoundingClientRect();
      requestAnimationFrame(() => { previous.style.opacity = '0'; });
      previous.addEventListener('transitionend', () => previous.remove(), { once: true });
      setTimeout(() => previous.remove(), 300);
    }
    image.src = src;
  }
  const caption = item.dataset.previewCaption || title.dataset.defaultTitle;
  title.textContent = window.basicLocale?.t(caption) || caption;
  image.alt = title.textContent;
  const href = item.dataset.preview ? item.getAttribute('href') : card.dataset.defaultHref;
  card.href = window.basicLocale?.url(href) || href;
}

function menuPosition(button, width) {
  const rect = button.getBoundingClientRect();
  const headerRect = header.getBoundingClientRect();
  return Math.max(18, Math.min(window.innerWidth - width - 18, rect.left - headerRect.left + rect.width / 2 - width / 2));
}

function positionActiveMenu() {
  if (!activeMenu) return;
  const trigger = triggers.find(button => button.dataset.menu === activeMenu);
  const config = menus[activeMenu];
  const width = Math.min(config.width, window.innerWidth - 36);
  menuPanel.style.left = `${menuPosition(trigger, width)}px`;
  menuPanel.style.width = `${width}px`;
  menuPanel.style.height = `${config.height}px`;
}

function openMenu(key, button) {
  if (window.innerWidth <= 900 || !menus[key]) return;
  clearTimeout(closeTimer);
  clearTimeout(renderTimer);
  closeSearch();
  const firstOpen = !activeMenu;
  const sequence = ++menuSequence;
  activeMenu = key;
  triggers.forEach(trigger => {
    const isActive = trigger === button;
    trigger.classList.toggle('active', isActive);
    trigger.setAttribute('aria-expanded', String(isActive));
  });
  menuInner.classList.remove('visible');
  if (firstOpen) {
    menuPanel.style.left = `${Math.max(18,button.getBoundingClientRect().left)}px`;
    menuPanel.style.width = `${button.getBoundingClientRect().width}px`;
    menuPanel.style.height = '42px';
    menuPanel.classList.add('open');
    menuPanel.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => positionActiveMenu());
  } else {
    positionActiveMenu();
  }
  renderTimer = setTimeout(() => {
    if (sequence !== menuSequence) return;
    menuInner.innerHTML = menus[key].html;
    refineControlIcons(menuInner);
    menuInner.classList.add('visible');
    preloadMenuPreviews();
  }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : firstOpen ? 190 : 100);
}

function closeMenu() {
  clearTimeout(closeTimer);
  clearTimeout(renderTimer);
  menuSequence++;
  activeMenu = null;
  menuInner.classList.remove('visible');
  menuPanel.classList.remove('open');
  menuPanel.setAttribute('aria-hidden', 'true');
  triggers.forEach(trigger => {trigger.classList.remove('active');trigger.setAttribute('aria-expanded','false');});
}

function scheduleClose() {clearTimeout(closeTimer);closeTimer = setTimeout(closeMenu, 180);}
triggers.forEach(button => {
  button.addEventListener('pointerenter', event => {if (event.pointerType !== 'touch') openMenu(button.dataset.menu, button);});
  button.addEventListener('focus', () => openMenu(button.dataset.menu, button));
  button.addEventListener('click', () => openMenu(button.dataset.menu, button));
  button.addEventListener('keydown', event => {
    if (event.key !== 'ArrowDown') return;
    event.preventDefault();
    openMenu(button.dataset.menu, button);
    clearTimeout(renderTimer);
    menuInner.innerHTML = menus[button.dataset.menu].html;
    refineControlIcons(menuInner);
    menuInner.classList.add('visible');
    preloadMenuPreviews();
    menuInner.querySelector('a')?.focus();
  });
});
header.addEventListener('pointerleave', scheduleClose);
header.addEventListener('pointerenter', () => clearTimeout(closeTimer));
menuPanel.addEventListener('pointerenter', () => clearTimeout(closeTimer));
menuPanel.addEventListener('pointermove', event => {
  if (event.pointerType === 'touch' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const bounds = menuPanel.getBoundingClientRect();
  menuPanel.style.setProperty('--glass-x', `${Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100))}%`);
  menuPanel.style.setProperty('--glass-y', `${Math.max(0, Math.min(100, (event.clientY - bounds.top) / bounds.height * 100))}%`);
});
menuPanel.addEventListener('pointerleave', () => {
  menuPanel.style.removeProperty('--glass-x');
  menuPanel.style.removeProperty('--glass-y');
  scheduleClose();
});
menuPanel.addEventListener('focusout', event => {if (!menuPanel.contains(event.relatedTarget) && !triggers.includes(event.relatedTarget)) scheduleClose();});
function updateMenuPreview(event) {
  if (event.pointerType === 'touch') return;
  const item = event.target.closest('.mega-link, .mega-small-link');
  if (!item || !menuPanel.contains(item)) return;
  updateProductPreview(item);
}
menuPanel.addEventListener('pointerover', updateMenuPreview);
menuPanel.addEventListener('focusin', updateMenuPreview);
window.addEventListener('resize', () => {if (window.innerWidth <= 900) closeMenu();else positionActiveMenu();});

const searchToggle = document.querySelector('.search-toggle');
const searchPanel = document.querySelector('#search-panel');
let searchHideTimer;
let searchSequence = 0;
searchPanel.inert = true;
searchPanel.setAttribute('aria-hidden', 'true');
function closeSearch() {
  if (searchPanel.hidden && searchToggle.getAttribute('aria-expanded') !== 'true') return;
  clearTimeout(searchHideTimer);
  searchSequence++;
  if (searchPanel.contains(document.activeElement)) searchToggle.focus();
  searchPanel.classList.remove('open');
  searchPanel.inert = true;
  searchPanel.setAttribute('aria-hidden', 'true');
  searchToggle.setAttribute('aria-expanded', 'false');
  searchHideTimer = setTimeout(() => {
    if (!searchPanel.classList.contains('open')) searchPanel.hidden = true;
  }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 350);
}
searchToggle.addEventListener('click', () => {
  if (mobileMenu.classList.contains('open')) closeMobileMenu(false);
  if (searchToggle.getAttribute('aria-expanded') === 'true') {closeSearch();return;}
  closeMenu();
  clearTimeout(searchHideTimer);
  const sequence = ++searchSequence;
  searchPanel.hidden = false;
  searchPanel.inert = false;
  searchPanel.setAttribute('aria-hidden', 'false');
  searchToggle.setAttribute('aria-expanded', 'true');
  searchPanel.getBoundingClientRect();
  requestAnimationFrame(() => {
    if (sequence !== searchSequence) return;
    searchPanel.classList.add('open');
    requestAnimationFrame(() => {
      if (sequence === searchSequence) document.querySelector('#site-search').focus();
    });
  });
});

const mobileToggle = document.querySelector('.mobile-toggle');
const mobileClose = document.querySelector('.mobile-close');
const mobileMenu = document.querySelector('#mobile-menu');
const mobileBackdrop = document.querySelector('#mobile-backdrop');
const mobileGroups = [...mobileMenu.querySelectorAll('.mobile-nav-group')];
const mobileBackground = [...document.querySelectorAll('main, footer, #mobile-sticky-cta')];
let backdropTimer;
function openMobileMenu() {
  refineControlIcons(mobileMenu);
  closeMenu();closeSearch();clearTimeout(backdropTimer);
  mobileGroups.forEach(group => {group.open = false;});
  mobileMenu.scrollTop = 0;
  mobileBackdrop.hidden = false;
  requestAnimationFrame(() => {mobileBackdrop.classList.add('open');mobileMenu.classList.add('open');});
  mobileMenu.removeAttribute('inert');mobileMenu.setAttribute('aria-hidden','false');mobileToggle.setAttribute('aria-expanded','true');
  mobileToggle.setAttribute('aria-label','Fermer le menu');
  mobileBackground.forEach(region => {region.inert = true;});
  document.body.classList.add('menu-locked');mobileClose.focus();
}
function closeMobileMenu(restoreFocus = true) {
  mobileBackdrop.classList.remove('open');mobileMenu.classList.remove('open');
  mobileMenu.setAttribute('inert','');mobileMenu.setAttribute('aria-hidden','true');mobileToggle.setAttribute('aria-expanded','false');
  mobileToggle.setAttribute('aria-label','Ouvrir le menu');
  mobileBackground.forEach(region => {region.inert = false;});
  document.body.classList.remove('menu-locked');
  backdropTimer = setTimeout(() => {mobileBackdrop.hidden = true;}, 350);
  if (restoreFocus) mobileToggle.focus();
}
mobileToggle.addEventListener('click', () => mobileMenu.classList.contains('open') ? closeMobileMenu() : openMobileMenu());
mobileClose.addEventListener('click', closeMobileMenu);
mobileBackdrop.addEventListener('click', closeMobileMenu);
mobileMenu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => closeMobileMenu(false)));
mobileGroups.forEach(group => group.addEventListener('toggle', () => {
  if (group.open) mobileGroups.forEach(other => {if (other !== group) other.open = false;});
}));
document.querySelector('.cart-link').addEventListener('click', () => {
  if (mobileMenu.classList.contains('open')) closeMobileMenu(false);
});
window.addEventListener('resize', () => {
  if (window.innerWidth > 900 && mobileMenu.classList.contains('open')) closeMobileMenu(false);
});
document.addEventListener('keydown', event => {
  if (event.key === 'Tab' && mobileMenu.classList.contains('open')) {
    const focusable = [...mobileMenu.querySelectorAll('button, a, summary')].filter(element => element.getClientRects().length > 0);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!mobileMenu.contains(document.activeElement)) {event.preventDefault();(event.shiftKey ? last : first)?.focus();}
    else if (event.shiftKey && document.activeElement === first) {event.preventDefault();last?.focus();}
    else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first?.focus();}
  }
  if (event.key === 'Escape') {
    if (mobileMenu.classList.contains('open')) closeMobileMenu();
    else if (searchToggle.getAttribute('aria-expanded') === 'true') {closeSearch();searchToggle.focus();}
    else if (activeMenu) {const button=triggers.find(item=>item.dataset.menu===activeMenu);button?.focus();closeMenu();}
  }
});
document.addEventListener('pointerdown', event => {if (!header.contains(event.target)) {closeMenu();closeSearch();}});

const sticky = document.querySelector('#mobile-sticky-cta');
const stickyHero = document.querySelector('.home-rose-hero, .deodorant-hero');
const stickyClosing = document.querySelector('.closing-cta');
if (sticky && stickyHero && stickyClosing) {
  function updateSticky() {
    const heroBottom = stickyHero.getBoundingClientRect().bottom;
    const closingTop = stickyClosing.getBoundingClientRect().top;
    sticky.classList.toggle('visible', heroBottom < 0 && closingTop > window.innerHeight * .8);
  }
  window.addEventListener('scroll', updateSticky, {passive:true});
  window.addEventListener('resize', updateSticky);
  updateSticky();
}

const bestsellerTrack = document.querySelector('#bestseller-track');
if (bestsellerTrack) {
  const cards = [...bestsellerTrack.querySelectorAll('.home-product-card')];
  const previous = document.querySelector('[data-carousel-direction="-1"]');
  const next = document.querySelector('[data-carousel-direction="1"]');

  function updateBestsellerControls() {
    const maxScroll = Math.max(0, bestsellerTrack.scrollWidth - bestsellerTrack.clientWidth);
    previous.disabled = bestsellerTrack.scrollLeft <= 3;
    next.disabled = bestsellerTrack.scrollLeft >= maxScroll - 3;
  }

  function moveBestsellers(direction) {
    if (cards.length < 2) return;
    const step = cards[1].offsetLeft - cards[0].offsetLeft;
    bestsellerTrack.scrollBy({
      left: step * direction,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  }

  previous.addEventListener('click', () => moveBestsellers(-1));
  next.addEventListener('click', () => moveBestsellers(1));
  bestsellerTrack.addEventListener('keydown', event => {
    if (event.target !== bestsellerTrack || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    moveBestsellers(event.key === 'ArrowRight' ? 1 : -1);
  });
  bestsellerTrack.addEventListener('scroll', updateBestsellerControls, {passive: true});
  window.addEventListener('resize', updateBestsellerControls);
  document.documentElement.classList.add('carousel-ready');
  updateBestsellerControls();
}

const pressViewport = document.querySelector('#press-logos');
if (pressViewport) {
  const pressSection = pressViewport.closest('.brand-press');
  const pressControls = pressSection.querySelector('.brand-press-controls');
  const pressPrevious = pressSection.querySelector('[data-press-direction="-1"]');
  const pressNext = pressSection.querySelector('[data-press-direction="1"]');
  const pressLogos = [...pressViewport.querySelectorAll('.brand-press-names li')];

  function updatePressControls() {
    const maxScroll = Math.max(0, pressViewport.scrollWidth - pressViewport.clientWidth);
    pressControls.hidden = maxScroll <= 3;
    pressViewport.tabIndex = maxScroll > 3 ? 0 : -1;
    pressPrevious.disabled = pressViewport.scrollLeft <= 3;
    pressNext.disabled = pressViewport.scrollLeft >= maxScroll - 3;
  }

  function movePress(direction) {
    if (pressLogos.length < 2) return;
    const step = pressLogos[1].offsetLeft - pressLogos[0].offsetLeft;
    pressViewport.scrollBy({
      left: step * direction,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  }

  pressPrevious.addEventListener('click', () => movePress(-1));
  pressNext.addEventListener('click', () => movePress(1));
  pressViewport.addEventListener('keydown', event => {
    if (event.target !== pressViewport || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    movePress(event.key === 'ArrowRight' ? 1 : -1);
  });
  pressViewport.addEventListener('scroll', updatePressControls, {passive: true});
  window.addEventListener('resize', updatePressControls);
  updatePressControls();
}

const familyTrack = document.querySelector('#family-grid');
if (familyTrack && familyTrack.querySelector('.family-card') && document.querySelector('[data-family-direction="-1"]') && document.querySelector('[data-family-direction="1"]')) {
  const familyCards = [...familyTrack.querySelectorAll('.family-card')];
  const familyPrevious = document.querySelector('[data-family-direction="-1"]');
  const familyNext = document.querySelector('[data-family-direction="1"]');

  function nearestFamilyIndex() {
    return familyCards.reduce((nearest, card, index) =>
      Math.abs(card.offsetLeft - familyTrack.scrollLeft) < Math.abs(familyCards[nearest].offsetLeft - familyTrack.scrollLeft) ? index : nearest, 0);
  }

  function updateFamilyControls() {
    const maxScroll = Math.max(0, familyTrack.scrollWidth - familyTrack.clientWidth);
    const currentIndex = nearestFamilyIndex();
    familyPrevious.disabled = currentIndex === 0;
    familyNext.disabled = currentIndex === familyCards.length - 1 || familyTrack.scrollLeft >= maxScroll - 3;
  }

  function moveFamilies(direction) {
    if (familyCards.length < 2) return;
    const targetIndex = Math.max(0, Math.min(familyCards.length - 1, nearestFamilyIndex() + direction));
    familyTrack.scrollTo({
      left: targetIndex === 0 ? 0 : familyCards[targetIndex].offsetLeft,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });
  }

  familyPrevious.addEventListener('click', () => moveFamilies(-1));
  familyNext.addEventListener('click', () => moveFamilies(1));
  familyTrack.addEventListener('keydown', event => {
    if (event.target !== familyTrack || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    moveFamilies(event.key === 'ArrowRight' ? 1 : -1);
  });
  familyTrack.addEventListener('scroll', updateFamilyControls, {passive: true});
  window.addEventListener('resize', updateFamilyControls);
  document.documentElement.classList.add('family-carousel-ready');
  updateFamilyControls();
}

/* Collection selections update in place while retaining native, shareable URLs. */
(() => {
  const main = document.querySelector('main.collection-main');
  const tabs = main?.querySelector('.collection-tabs');
  if (!tabs) return;

  const links = [...tabs.querySelectorAll('a[href]')];
  const keyFor = value => {
    const url = new URL(value, location.href);
    url.hash = '';
    return url.href;
  };
  const initialKey = keyFor(location.href);
  const allowed = new Set([initialKey, ...links.map(link => keyFor(link.href))]);
  const parts = ['.collection-breadcrumb', '.collection-hero', '.collection-selection', '.collection-editorial', '.collection-all'];
  const language = document.documentElement.lang.slice(0, 2);
  const copy = ({
    fr: {loading:'Chargement…', ready:'Sélection : ', error:'La sélection n’a pas pu charger. Réessaie.'},
    de: {loading:'Wird geladen…', ready:'Auswahl: ', error:'Die Auswahl konnte nicht geladen werden. Bitte erneut versuchen.'},
    en: {loading:'Loading…', ready:'Selection: ', error:'The selection could not load. Please try again.'}
  })[language] || {loading:'Chargement…', ready:'Sélection : ', error:'La sélection n’a pas pu charger. Réessaie.'};
  const status = document.createElement('p');
  status.className = 'sr-only';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-atomic', 'true');
  tabs.after(status);

  function snapshot(root) {
    const selected = root.querySelector('.collection-tabs a[aria-current="page"]');
    if (!selected || !root.querySelector('.collection-selection') || !root.querySelector('.collection-hero')) throw new Error('Missing collection selection');
    return {
      label: selected.textContent.trim(),
      canonical: keyFor(selected.getAttribute('href')),
      description: root.querySelector('.collection-hero p')?.textContent.trim() || '',
      parts: parts.map(selector => root.querySelector(selector)?.outerHTML || null)
    };
  }

  const initialView = snapshot(main);
  const cache = new Map([[initialKey, Promise.resolve(initialView)], [initialView.canonical, Promise.resolve(initialView)]]);
  let currentKey = initialKey;
  let requestNumber = 0;
  const previousScrollRestoration = history.scrollRestoration;
  history.scrollRestoration = 'manual';
  history.replaceState({...history.state, basicCollection:{key:initialKey, y:scrollY}}, '', location.href);
  window.addEventListener('pagehide', () => {history.scrollRestoration = previousScrollRestoration;});
  window.addEventListener('pageshow', () => {history.scrollRestoration = 'manual';});

  function load(key) {
    if (cache.has(key)) return cache.get(key);
    const request = new URL(key);
    // The static section ID also works across different collection templates.
    if (window.BasicShopifyConfig) request.searchParams.set('section_id', 'basic-site-page');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 10000);
    const pending = fetch(request.href, {credentials:'same-origin', signal:controller.signal})
      .then(response => {
        if (!response.ok) throw new Error('Collection request failed');
        return response.text();
      })
      .then(html => snapshot(new DOMParser().parseFromString(html, 'text/html').querySelector('main.collection-main')))
      .catch(error => {cache.delete(key); throw error;})
      .finally(() => clearTimeout(timeout));
    cache.set(key, pending);
    return pending;
  }

  function render(view, restoreY) {
    const tabTop = tabs.getBoundingClientRect().top;
    parts.forEach((selector, index) => {
      const previous = main.querySelector(selector);
      const html = view.parts[index];
      if (previous && html) previous.outerHTML = html;
      else if (previous) previous.remove();
    });
    links.forEach(link => {
      if (keyFor(link.href) === view.canonical) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    refineControlIcons(main);
    window.BasicShopifyCatalog?.sync(main);
    // Compensate different hero heights, including on small screens.
    const targetY = typeof restoreY === 'number' ? restoreY : scrollY + tabs.getBoundingClientRect().top - tabTop;
    window.scrollTo({top:targetY, behavior:'instant'});
    document.title = `${view.label} | basic.`;
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.href = view.canonical;
    for (const [selector, value] of [
      ['meta[property="og:url"]', view.canonical],
      ['meta[property="og:title"]', document.title],
      ['meta[name="description"]', view.description],
      ['meta[property="og:description"]', view.description]
    ]) document.querySelector(selector)?.setAttribute('content', value);
    const handle = new URL(view.canonical).pathname.match(/\/collections\/([^/]+)\/?$/)?.[1];
    if (handle) document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(link => {
      const url = new URL(link.href);
      url.pathname = url.pathname.replace(/\/collections\/[^/]+\/?$/, `/collections/${handle}`);
      link.href = url.href;
    });
  }

  async function switchSelection(key, {pop=false, restoreY} = {}) {
    const ownRequest = ++requestNumber;
    status.className = 'sr-only';
    status.textContent = copy.loading;
    main.setAttribute('aria-busy', 'true');
    main.classList.add('is-switching');
    links.forEach(link => link.classList.toggle('is-pending', keyFor(link.href) === key));
    try {
      const view = await load(key);
      if (ownRequest !== requestNumber) return;
      if (!pop) history.replaceState({...history.state, basicCollection:{key:currentKey, y:scrollY}}, '', location.href);
      render(view, restoreY);
      currentKey = key;
      if (!pop) history.pushState({...history.state, basicCollection:{key, y:scrollY}}, '', key);
      status.textContent = copy.ready + view.label;
    } catch {
      if (ownRequest !== requestNumber) return;
      if (pop) {location.assign(location.href); return;}
      status.className = 'collection-switch-error';
      status.textContent = copy.error;
    } finally {
      if (ownRequest === requestNumber) {
        main.removeAttribute('aria-busy');
        main.classList.remove('is-switching');
        links.forEach(link => link.classList.remove('is-pending'));
      }
    }
  }

  tabs.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
    const key = keyFor(link.href);
    if (!allowed.has(key) || new URL(key).origin !== location.origin) return;
    event.preventDefault();
    if (key === currentKey && !main.hasAttribute('aria-busy')) return;
    switchSelection(key);
  });
  window.addEventListener('popstate', event => {
    const entry = event.state?.basicCollection;
    if (entry && allowed.has(entry.key)) switchSelection(entry.key, {pop:true, restoreY:entry.y});
  });
  // Prepare the other selections in the background for instant later switches.
  const prefetch = () => links.forEach(link => load(keyFor(link.href)).catch(() => {}));
  if ('requestIdleCallback' in window) requestIdleCallback(prefetch, {timeout:2000});
  else setTimeout(prefetch, 500);
})();
